// extracted by css-extract-rspack-plugin
export default {"cls1":"CourseResults-cls1_EzW","cls2":"CourseResults-cls2_pgw CourseResults-cls1_EzW"};